var _rect, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOctaveDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    rx: 60,
    fill: "#242938"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.8516 48.7731C30.8478 82.4656 38.3617 145.254 78.6254 189.01C118.889 232.765 176.658 240.92 207.662 207.228C238.666 173.535 231.173 110.744 190.909 66.9886C150.646 23.2331 92.8555 15.0805 61.8516 48.7731V48.7731ZM89.9653 62.769C114.326 36.2956 159.117 42.0543 190.017 75.6337C220.917 109.213 226.216 157.889 201.855 184.362C177.494 210.836 132.691 205.09 101.792 171.51C70.8917 137.931 65.6045 89.2424 89.9653 62.769V62.769Z",
    fill: "url(#paint0_radial_307_195)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M196.287 60.7383H179.516C176.98 60.7383 174.924 62.7943 174.924 65.3305V82.1019C174.924 84.6381 176.98 86.6941 179.516 86.6941H196.287C198.824 86.6941 200.88 84.6381 200.88 82.1019V65.3305C200.88 62.7943 198.824 60.7383 196.287 60.7383Z",
    fill: "#FF7F2A",
    stroke: "#D45500",
    strokeWidth: 6.28859
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3188 94.9331H39.8162C33.8426 94.9331 29 99.7757 29 105.749V145.252C29 151.225 33.8426 156.068 39.8162 156.068H79.3188C85.2924 156.068 90.135 151.225 90.135 145.252V105.749C90.135 99.7757 85.2924 94.9331 79.3188 94.9331Z",
    fill: "#FF7F2A",
    stroke: "#D45500",
    strokeWidth: 6.28859
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M217.396 174.966H193.531C189.922 174.966 186.996 177.892 186.996 181.501V205.366C186.996 208.975 189.922 211.901 193.531 211.901H217.396C221.005 211.901 223.931 208.975 223.931 205.366V181.501C223.931 177.892 221.005 174.966 217.396 174.966Z",
    fill: "#FF7F2A",
    stroke: "#D45500",
    strokeWidth: 6.28859
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_307_195",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(89.314 200.307) rotate(-47.3797) scale(300.774 999.837)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008CBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2FFFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOctaveDark);
export default __webpack_public_path__ + "static/media/Octave-Dark.28048d72547ae69e903e1d5f359cf82d.svg";
export { ForwardRef as ReactComponent };